import {
  BlogFeedResponseModel,
  BlogGetUser2ResponseModel,
  UserSuggestionsResponseModel,
  BlogFollowResponseModel,
  BlogActivityResponseModel,
  BlogPostResponseModel,
  BlogSearchTagResponseModel,
  BlogSearchUserResponseModel,
  BlogSearchTagAndUserResponseModel,
  UserFollowersResponseModel,
  UserFolloweesResponseModel,
  BlogActivityCountResponseModel,
  UserBlocksResponseModel,
  BlogCreatePostResponseModel,
  BlogDeletePostResponseModel,
  GetFollowRequestsResponseModel,
} from './../../../core/model/api-response/blog-response-model';
import { Injectable } from '@angular/core';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { UserDataService } from '../user-repository/user-data.service';
import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpHeaders,
} from '@angular/common/http';
import { BlogUserService } from './blog-user.service';
import {
  BlogTokenRefreshResponse,
  BlogUserTokenModel,
  BlogGetUserResponseModel,
  BlogListResponseModel,
  BlogLikeResponseModel,
  BlogCreateCommentOrReplyResponseModel,
  BlogDeleteCommentResponseModel,
  BlogReportResponseModel,
  BlogEditProfileResponseModel,
  BlogValidateUsernameResponseModel,
  BlogImageProfileResponseModel,
} from 'src/app/core/model/api-response/blog-response-model';
import { blogBaseUrl } from 'src/app/global-variables';
import { BlogUserModel } from 'src/app/core/model/object/blog-user-model';
import {
  BlogPostModel,
  BlogListModel,
  BlogTagModel,
  BlogCommentsArrayModel,
  BlogCommentModel,
  BlogReplyModel,
} from 'src/app/core/model/object/blog-model';
import { LogoutService } from '../user-repository/logout.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BlogApiService {
  constructor(
    private http: HttpClient,
    private blogUserService: BlogUserService,
    private userDataService: UserDataService,
    private logoutService: LogoutService
  ) {}

  createBlogUserToken(): Promise<GenericResponse> {
    let response: GenericResponse;
    const authorization = 'Bearer ' + this.userDataService.getToken();
    const headerDict = {
      Authorization: authorization,
    };
    return this.http
      .post<BlogUserTokenModel>(
        'https://bentoapp.org/api/v2/users/blog/auth',
        {},
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        if (res.success) {
          this.blogUserService.saveBlogToken(res.token);
          response = new GenericResponse(true);
        } else {
          response = new GenericResponse(false);
        }
        return response;
      })
      .catch((e) => {
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  async getBlogUser(getUser?: boolean): Promise<GenericResponse> {
    let token = await this.blogUserService.getBlogToken();
    if (!token) {
      await this.createBlogUserToken().then(async (res) => {
        if (res.isSuccess()) {
          token = await this.blogUserService.getBlogToken();
        }
      });
    }

    const headerDict = {
      'x-access-token': token,
    };

    return this.http
      .get<BlogGetUserResponseModel>(blogBaseUrl + '/api/v1/users', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((res) => {
        console.log(res);

        if (res.success) {
          let blogUser: BlogUserModel;
          if (res.data['userName']) {
            blogUser = new BlogUserModel(
              res.data['id'],
              res.data['userName'],
              res.data['avatarPath'],
              res.data['bio'],
              res.data['status'],
              res.data['name'],
              res.data['avatar'],
              res.data['enabled']
            );
          } else {
            blogUser = new BlogUserModel(
              res.data['id'],
              '',
              res.data['avatarPath'],
              res.data['bio'],
              res.data['status'],
              res.data['name'],
              res.data['avatar'],
              true
            );
          }
          this.blogUserService.saveBlogUser(blogUser);
          if (getUser) {
            return new GenericResponse(
              res.success,
              new GenericResponseData({ blogUserId: res.data['id'] })
            );
          }

          return new GenericResponse(
            res.success,
            new GenericResponseData({
              blogUser: res.data as BlogUserModel,
            })
          );
        }
        return new GenericResponse(res.success);
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getBlogUser();
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  editBlogUser(
    name?: string,
    username?: string,
    bio?: string,
    status?: string,
    avatar?: string
  ): Promise<GenericResponse> {
    return this.blogUserService.getBlogUser().then((usr) => {
      let user = usr;
      let response: GenericResponse;
      // console.log(name, sex, birthDate, weight, height)
      if (name) {
        user.name = name;
      }
      if (username) {
        user.userName = username;
      }
      if (bio) {
        user.bio = bio;
      }
      if (status) {
        user.status = status;
      }
      user.avatar = avatar;
      // console.log(user)
      const headerDict = {
        'x-access-token': this.blogUserService.getBlogToken(),
      };
      return this.http
        .patch<BlogEditProfileResponseModel>(
          blogBaseUrl + '/api/v1/users',
          {
            market: 'pwa',
            username: user.userName,
            bio: user.bio,
            status: user.status,
            name: user.name,
            avatar: user.avatar === '' ? '-' : user.avatar,
          },
          {
            headers: new HttpHeaders(headerDict),
          }
        )
        .toPromise()
        .then((res) => {
          if (res.success) {
            res.user.avatar = res.user.avatar === '-' ? '' : res.user.avatar;
            this.blogUserService.saveBlogUser(res.user);
          }
          const data = new GenericResponseData({ message: res.message });
          response = new GenericResponse(res.success, data);
          return response;
        })
        .catch((e) => {
          if (e.status === 403 || e.status === 401) {
            this.refreshBlogToken().then((resp) => {
              if (resp.isSuccess()) {
                this.editBlogUser(name, username, bio, status, avatar);
              }
            });
          }
          response = new GenericResponse(
            false,
            new GenericResponseData({ message: 'خطای اتصال' })
          );
          return response;
        });
    });
  }

  // BlogEditProfile(username: string, ): Promise<GenericResponse> {
  //   const headerDict = {
  //     'x-access-token': this.blogUserService.getBlogToken()
  //   };
  //   return this.http.patch<BlogEditProfileResponseModel>((blogBaseUrl + '/api/v1/users'),
  //     {
  //       username,
  //       avatar
  //     },
  //     {
  //       headers: new HttpHeaders(headerDict)
  //     }).toPromise()
  //     .then(
  //       (res) => {
  //         return new GenericResponse(res.success);
  //       }
  //     ).catch((e) => {
  //       console.log(e.status, e);
  //       if (e.status === 403 || e.status === 401) {
  //         this.refreshBlogToken().then((resp) => {
  //           if (resp.isSuccess()) {
  //             this.BlogEditProfile(username, avatar);
  //           }
  //         });
  //       }
  //       const response = new GenericResponse(false, new GenericResponseData({message: 'خطای اتصال'}));
  //       return response;
  //     });
  // }

  getBlogUser2(username: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<BlogGetUser2ResponseModel>(
        blogBaseUrl + '/api/v1/users/-1?userName=' + username,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        if (res.success) {
          // let blogUser: BlogUserModel;
          // if (res.data['userName']) {
          //   blogUser = new BlogUserModel(res.data['id'], res.data['userName'], res.data['avatarPath'],
          //     res.data['bio'], res.data['status'], res.data['name']);
          // } else {
          //   blogUser = new BlogUserModel(res.data['id'], '', res.data['avatarPath'],
          //   res.data['bio'], res.data['status'], res.data['name']);
          // }
        }
        return new GenericResponse(
          res.success,
          new GenericResponseData({ blogGetUserModel: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getBlogUser();
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  getBlogPostsList(page: number, limit: number): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<BlogFeedResponseModel>(
        blogBaseUrl + '/api/v1/feed?page=' + page + '&limit=' + limit,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((blogListResponseModel) => {
        if (blogListResponseModel.success) {
          const blogPostsArray = new Array<BlogPostModel>();
          const keys = Object.keys(blogListResponseModel.posts);
          for (const key of keys) {
            const user = new BlogUserModel(
              blogListResponseModel.posts[key].user._id,
              blogListResponseModel.posts[key].user.userName,
              blogListResponseModel.posts[key].user.avatarPath,
              '',
              '',
              blogListResponseModel.posts[key].user.name,
              '',
              true
            );
            blogPostsArray.push(
              new BlogPostModel(
                blogListResponseModel.posts[key]._id,
                blogListResponseModel.posts[key].createdAt,
                blogListResponseModel.posts[key].comments,
                blogListResponseModel.posts[key].likes,
                blogListResponseModel.posts[key].isLiked,
                user,
                blogListResponseModel.posts[key].text,
                blogListResponseModel.posts[key].featuredImagePath,
                blogListResponseModel.posts[key].featured
              )
            );
          }
          // console.log('sss', blogPostsArray)
          const blogList = new BlogListModel(
            blogPostsArray,
            null,
            blogListResponseModel.count
          );
          return new GenericResponse(
            true,
            new GenericResponseData({ blogList })
          );
        }
        return new GenericResponse(false);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getBlogPostsList(page, limit);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  getFollowRequests(page: number, limit: number): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<GetFollowRequestsResponseModel>(
        blogBaseUrl + '/api/v1/follow?page=' + page + '&limit=' + limit,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ blogFollowRequests: res })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getFollowRequests(page, limit);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  setFollowRequest(userId: string, status: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .patch<GetFollowRequestsResponseModel>(
        blogBaseUrl + '/api/v1/follow/' + userId,
        {
          status,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(res.success);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.setFollowRequest(userId, status);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  getBlogPost(postId: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<BlogPostResponseModel>(blogBaseUrl + '/api/v1/posts/' + postId, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ blogPost: res.data })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getBlogPost(postId);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  getUserPostsList(
    page: number,
    limit: number,
    username: string
  ): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<BlogFeedResponseModel>(
        blogBaseUrl +
          '/api/v1/users/' +
          username +
          '/posts?page=' +
          page +
          '&limit=' +
          limit,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((blogListResponseModel) => {
        if (blogListResponseModel.success) {
          const blogPostsArray = new Array<BlogPostModel>();
          const keys = Object.keys(blogListResponseModel.posts);
          for (const key of keys) {
            const user = new BlogUserModel(
              blogListResponseModel.posts[key].user.id,
              blogListResponseModel.posts[key].user.userName,
              blogListResponseModel.posts[key].user.avatarPath,
              '',
              '',
              blogListResponseModel.posts[key].user.name,
              '',
              true
            );
            blogPostsArray.push(
              new BlogPostModel(
                blogListResponseModel.posts[key]._id,
                blogListResponseModel.posts[key].createdAt,
                blogListResponseModel.posts[key].comments,
                blogListResponseModel.posts[key].likes,
                blogListResponseModel.posts[key].isLiked,
                user,
                blogListResponseModel.posts[key].text,
                blogListResponseModel.posts[key].featuredImagePath
              )
            );
          }
          // console.log('sss', blogPostsArray)
          const blogList = new BlogListModel(
            blogPostsArray,
            null,
            blogListResponseModel.count
          );
          return new GenericResponse(
            true,
            new GenericResponseData({ blogList })
          );
        }
        return new GenericResponse(false);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getUserPostsList(page, limit, username);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  getActivityList(page: number, limit: number): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<BlogActivityResponseModel>(
        blogBaseUrl + '/api/v1/activity?page=' + page + '&limit=' + limit,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ blogActivityResponse: res })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getActivityList(page, limit);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  getActivityCount(): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<BlogActivityCountResponseModel>(
        blogBaseUrl + '/api/v1/activity/count',
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({
            blogActivityResponse: new BlogActivityResponseModel(
              true,
              res.unreadCount,
              null
            ),
          })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getActivityCount();
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  userSuggestions(): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<UserSuggestionsResponseModel>(
        blogBaseUrl + '/api/v1/users/suggestions',
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ blogUsers: res.suggestions })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.userSuggestions();
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  userBlockList(): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<UserBlocksResponseModel>(blogBaseUrl + '/api/v1/block', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ blogUsers: res.blockedUsers })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.userBlockList();
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  userBlock(userId: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .post<UserBlocksResponseModel>(
        blogBaseUrl + '/api/v1/block',
        {
          userId,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ blogUsers: res.blockedUsers })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.userBlock(userId);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  mutuals(): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<UserSuggestionsResponseModel>(
        blogBaseUrl +
          '/api/v1/users/mutuals?mutualUserId=5e0b8fda36521c455983bf00',
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ blogUsers: res.suggestions })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.mutuals();
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  follow(userId: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .post<BlogFollowResponseModel>(
        blogBaseUrl + '/api/v1/follow/' + userId,
        {},
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ message: res.message })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.follow(userId);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  postLike(postId: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .post<BlogLikeResponseModel>(
        blogBaseUrl + '/api/v1/postlikes',
        {
          postId,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(res.success);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.postLike(postId);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  postDislike(postId: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .delete<BlogLikeResponseModel>(
        blogBaseUrl + '/api/v1/postlikes/' + postId,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(res.success);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.postDislike(postId);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  getBlogPostsListWithTag(
    page: number,
    limit: number,
    tag: string
  ): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<BlogListResponseModel>(
        blogBaseUrl +
          '/api/v1/posts?page=' +
          page +
          '&limit=' +
          limit +
          '&tags=' +
          tag,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((blogListResponseModel) => {
        if (blogListResponseModel.success) {
          const blogPostsArray = new Array<BlogPostModel>();
          const keys = Object.keys(blogListResponseModel.data);
          for (const key of keys) {
            const user = new BlogUserModel(
              blogListResponseModel.data[key].user.id,
              blogListResponseModel.data[key].user.userName,
              blogListResponseModel.data[key].user.avatarPath,
              blogListResponseModel.data[key].user.bio,
              blogListResponseModel.data[key].user.status,
              blogListResponseModel.data[key].user.name,
              blogListResponseModel.data[key].user.avatar,
              true
            );
            blogPostsArray.push(
              new BlogPostModel(
                blogListResponseModel.data[key]._id,
                blogListResponseModel.data[key].createdAt,
                blogListResponseModel.data[key].comments,
                blogListResponseModel.data[key].likes,
                blogListResponseModel.data[key].isLiked,
                user,
                blogListResponseModel.data[key].text,
                blogListResponseModel.data[key].featuredImagePath
              )
            );
          }
          // console.log('sss', blogPostsArray)
          const blogList = new BlogListModel(
            blogPostsArray,
            null,
            blogListResponseModel.count
          );
          return new GenericResponse(
            true,
            new GenericResponseData({ blogList })
          );
        }
        return new GenericResponse(false);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getBlogPostsListWithTag(page, limit, tag);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  searchTag(title: string): Promise<GenericResponse> {
    return this.http
      .get<BlogSearchTagResponseModel>(
        blogBaseUrl + '/api/v1/tags?title=' + title,
        {}
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ blogTagArray: res.data })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  searchUser(title: string): Promise<GenericResponse> {
    return this.http
      .get<BlogSearchUserResponseModel>(
        blogBaseUrl + '/api/v1/search/users?q=' + title,
        {}
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ blogUsers: res.users })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  searchTagAndUser(title: string): Promise<GenericResponse> {
    return this.http
      .get<BlogSearchTagAndUserResponseModel>(
        blogBaseUrl + '/api/v1/search?q=' + title,
        {}
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({
            blogUsers: res.users,
            blogTagArray: res.tags,
          })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  userFollowers(
    page: number,
    limit: number,
    userId: string
  ): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<UserFollowersResponseModel>(
        blogBaseUrl +
          '/api/v1/follow/followers/' +
          userId +
          '?page=' +
          page +
          '&limit=' +
          limit,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({
            blogList: new BlogListModel(null, res.followers, res.count),
          })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  userFollowees(
    page: number,
    limit: number,
    userId: string
  ): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<UserFolloweesResponseModel>(
        blogBaseUrl +
          '/api/v1/follow/followees/' +
          userId +
          '?page=' +
          page +
          '&limit=' +
          limit,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({
            blogList: new BlogListModel(null, res.followees, res.count),
          })
        );
      })
      .catch((e) => {
        console.log(e.status, e);
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  getBlogPostComments(
    postId: string,
    startDate: string,
    limit: number
  ): Promise<GenericResponse> {
    return this.http
      .get<BlogListResponseModel>(
        blogBaseUrl +
          '/api/v1/posts/' +
          postId +
          '/comments?startDate=' +
          startDate +
          '&limit=' +
          limit,
        {}
      )
      .toPromise()
      .then((blogListResponseModel) => {
        let blogCommentsArrayModel: BlogCommentsArrayModel;
        if (blogListResponseModel.success) {
          const blogCommentsArray = new Array<BlogCommentModel>();
          let blogReplyArray = new Array<BlogReplyModel>();
          const keys = Object.keys(blogListResponseModel.data);
          for (const key of keys) {
            const keys2 = Object.keys(blogListResponseModel.data[key].replies);
            blogReplyArray = [];
            for (const k of keys2) {
              const userReply = new BlogUserModel(
                blogListResponseModel.data[key].replies[k].user.id,
                blogListResponseModel.data[key].replies[k].user.userName,
                blogListResponseModel.data[key].replies[k].user.avatarPath,
                blogListResponseModel.data[key].user.bio,
                blogListResponseModel.data[key].user.status,
                blogListResponseModel.data[key].user.name,
                blogListResponseModel.data[key].replies[k].user.avatar,
                true
              );
              blogReplyArray.push(
                new BlogReplyModel(
                  blogListResponseModel.data[key].replies[k]._id,
                  blogListResponseModel.data[key].replies[k].text,
                  userReply,
                  blogListResponseModel.data[key].replies[k].createdAt
                )
              );
            }
            const user = new BlogUserModel(
              blogListResponseModel.data[key].user.id,
              blogListResponseModel.data[key].user.userName,
              blogListResponseModel.data[key].user.avatarPath,
              blogListResponseModel.data[key].user.bio,
              blogListResponseModel.data[key].user.status,
              blogListResponseModel.data[key].user.name,
              blogListResponseModel.data[key].user.avatar,
              true
            );
            blogCommentsArray.push(
              new BlogCommentModel(
                blogListResponseModel.data[key]._id,
                blogListResponseModel.data[key].text,
                user,
                blogReplyArray,
                1,
                blogListResponseModel.data[key].createdAt
              )
            );
          }
          blogCommentsArrayModel = new BlogCommentsArrayModel(
            blogCommentsArray,
            blogListResponseModel.count
          );
          // console.log('sss', blogCommentsArray)
          return new GenericResponse(
            true,
            new GenericResponseData({ blogCommentsArrayModel })
          );
        }
        return new GenericResponse(false);
      })
      .catch((e) => {
        console.log(e.status, e);
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  createReply(commentId: string, text: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.blogUserService
      .getBlogUser()
      .then((result) => {
        const user = result;
        return this.http
          .post<BlogCreateCommentOrReplyResponseModel>(
            blogBaseUrl + '/api/v1/comments/' + commentId + '/reply',
            {
              text,
            },
            {
              headers: new HttpHeaders(headerDict),
            }
          )
          .toPromise()
          .then((res) => {
            if (res.success) {
              const blogReply = new BlogReplyModel(
                res.data['_id'],
                res.data['text'],
                user,
                res.data['createdAt']
              );
              return new GenericResponse(
                true,
                new GenericResponseData({ blogReply })
              );
            }
            return new GenericResponse(false);
          });
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.createReply(commentId, text);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  createComment(postId: string, text: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.blogUserService
      .getBlogUser()
      .then((result) => {
        const user = result;
        return this.http
          .post<BlogCreateCommentOrReplyResponseModel>(
            blogBaseUrl + '/api/v1/comments',
            {
              postId,
              text,
            },
            {
              headers: new HttpHeaders(headerDict),
            }
          )
          .toPromise()
          .then((res) => {
            if (res.success) {
              const blogComment = new BlogCommentModel(
                res.data['_id'],
                res.data['text'],
                user,
                [],
                0,
                res.data['createdAt']
              );
              return new GenericResponse(
                true,
                new GenericResponseData({ blogComment })
              );
            }
            return new GenericResponse(false);
          });
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.createComment(postId, text);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  deleteComment(commentId: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .delete<BlogDeleteCommentResponseModel>(
        blogBaseUrl + '/api/v1/comments/' + commentId,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(res.success);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.deleteComment(commentId);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  deleteReply(replyId: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .delete<BlogDeleteCommentResponseModel>(
        blogBaseUrl + '/api/v1/comments/' + replyId + '/reply',
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(res.success);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.deleteReply(replyId);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  reportBlogPost(postId: string, reason: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .post<BlogReportResponseModel>(
        blogBaseUrl + '/api/v1/posts/' + postId + '/reports',
        {
          reason,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(res.success);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.reportBlogPost(postId, reason);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  reportBlogComment(
    commentId: string,
    reason: string
  ): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .post<BlogReportResponseModel>(
        blogBaseUrl + '/api/v1/comments/' + commentId + '/reports',
        {
          reason,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(res.success);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.reportBlogComment(commentId, reason);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  reportBlogReply(replyId: string, reason: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .post<BlogReportResponseModel>(
        blogBaseUrl + '/api/v1/comments/' + replyId + '/reportReply',
        {
          reason,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(res.success);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.reportBlogReply(replyId, reason);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  validateUsername(username: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .get<BlogValidateUsernameResponseModel>(
        blogBaseUrl + '/api/v1/users/validate/username?username=' + username,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ message: res.message })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.validateUsername(username);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({
            message: 'این نام کاربری قبلا انتخاب شده است',
          })
        );
      });
  }

  setBlogImage(avatar: FormData): Promise<BlogImageProfileResponseModel> {
    return fetch(blogBaseUrl + '/api/v1/users/avatars', {
      method: 'POST',
      body: avatar,
      headers: { 'x-access-token': this.blogUserService.getBlogToken() },
    })
      .then((res) => res.json())
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.setBlogImage(avatar);
            }
          });
        }
        return new BlogImageProfileResponseModel(false, '', '', '');
      });
  }

  createPost(body: FormData): Observable<HttpEvent<Object>> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http.post(blogBaseUrl + '/api/v1/posts', body, {
      headers: new HttpHeaders(headerDict),
      reportProgress: true,
      observe: 'events',
    });

    // fetch(blogBaseUrl + '/api/v1/posts', {
    //   method: 'POST',
    //   body,
    //   headers: { 'x-access-token': this.blogUserService.getBlogToken() },
    // })
    //   .then((res) => res.json())
    //   .catch((e) => {
    //     console.log(e.status, e);
    //     if (e.status === 403 || e.status === 401) {
    //       this.refreshBlogToken().then((resp) => {
    //         if (resp.isSuccess()) {
    //           this.createPost(body);
    //         }
    //       });
    //     }
    //     return new BlogCreatePostResponseModel(false);
    //   });
  }

  deletePost(postId: string): Promise<GenericResponse> {
    const headerDict = {
      'x-access-token': this.blogUserService.getBlogToken(),
    };
    return this.http
      .delete<BlogDeletePostResponseModel>(
        blogBaseUrl + '/api/v1/posts/' + postId,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(res.success);
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.refreshBlogToken().then((resp) => {
            if (resp.isSuccess()) {
              this.deletePost(postId);
            }
          });
        }
        const response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }

  refreshBlogToken(): Promise<GenericResponse> {
    let response: GenericResponse;
    const authorization = 'Bearer ' + this.blogUserService.getBlogToken();
    const headerDict = {
      Authorization: authorization,
    };
    return this.http
      .post<BlogTokenRefreshResponse>(
        'http://185.8.172.223:8585/api/v2/users/blog/auth',
        {},
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        if (res.success) {
          this.blogUserService.saveBlogToken(res.token);
        } else {
          this.logoutService.logout();
        }
        response = new GenericResponse(res.success);
        return response;
      })
      .catch((e) => {
        this.logoutService.logout();
        response = new GenericResponse(false);
        return response;
      });
  }
}
